<div [formGroup]="bookOffForm">
  <ng-template #duration>
    <div formGroupName="duration" class="p-grid">

      <div class="p-col">
        <app-date-time-input
          formControlName="start"
          dateLabel="Start Date"
          timeLabel="Start Time"
          datePlaceholder="Enter Start Date"
          [dateFormat]="dateFormat"
          [timeFormat]="timeFormat"
          ></app-date-time-input>
        <app-validation-messages
          [control]="bookOffForm.get('duration.start')"
          [requireTouched]="true"
          fieldName="Start"
          ></app-validation-messages>
      </div>

      <div class="p-col">
        <app-date-time-input
          formControlName="end"
          dateLabel="End Date"
          timeLabel="End Time"
          datePlaceholder="Enter End Date"
          [dateFormat]="dateFormat"
          [timeFormat]="timeFormat"
          ></app-date-time-input>
        <app-validation-messages
          [control]="bookOffForm.get('duration.end')"
          [requireTouched]="true"
          fieldName="End"
          ></app-validation-messages>
      </div>
      <div class="p-col-12 p-text-center">
        <app-validation-messages
          [control]="bookOffForm.get('duration')"
          [requireTouched]="true"
          ></app-validation-messages>
      </div>
    </div>

  </ng-template>

  <ng-template #description>
    <label>Description</label>
    <br>
    <textarea
      pInputTextarea
      formControlName="description"
      placeholder="Optional: description for why this asset is booked off"
      class="full-width"
      ></textarea>
  </ng-template>

</div>

<ng-template #durationReview>
    <span>{{bookOffForm.value.duration.start | date : 'h:mm a, MMM, d, y'}} - {{bookOffForm.value.duration.end | date : 'h:mm a, MMM, d, y'}}</span>
</ng-template>

<app-mutate-object
    [fg]="bookOffForm"
    objectType="Book Off"
    [mutateType]="mutateType"
    [steps]="steps"
    (objectMutated)="mutateObject()"
    [titleText]="mutateType === 'create' ? 'Book Off Asset' : 'Edit Book Off'"
></app-mutate-object>
